export const doctype = {
    TRUCKER: 'Trucker',
    TRIP: 'Trip',
    TRUCK: 'Truck',
    COMPANY: 'Freight Company',
    USER: 'Freight User'
}